import DOMPurify from 'dompurify';

function RTEtext(props: { text: string; className?: string }) {
  const { text, className } = props;
  const createMarkup = (html: any) => ({ __html: DOMPurify.sanitize(html) });
  return (
    <>
      {
        <div
          className={className}
          dangerouslySetInnerHTML={createMarkup(text)} // eslint-disable-line react/no-danger
        />
      }
    </>
  );
}

RTEtext.defaultProps = {
  className: '',
};

export default RTEtext;
